import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const WALL_ST_BG = 'https://customer-assets.emergentagent.com/job_perfectbuild/artifacts/chmd9imm_d6776240-4dc4-45b1-b741-455b93d0f8fd%20%281%29.png';

export const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{
        background: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,0.28) 26%, rgba(0,0,0,0.55) 60%, rgba(0,0,0,0.93) 100%)',
      }}
    >
      <div className="relative max-w-5xl mx-auto px-6 lg:px-8 w-full py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          <motion.div
            initial={{ opacity: 0, x: -18 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="mb-10"
            style={{
              fontFamily: 'DM Sans',
              fontSize: '11px',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              color: '#6B7280',
              fontWeight: 500,
            }}
          >
            Private · Invitation Only
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.05, delay: 0.28, ease: [0.22, 1, 0.36, 1] }}
            className="mb-10"
            style={{
              fontFamily: 'Cormorant Garamond',
              fontSize: '72px',
              fontWeight: 600,
              color: '#FFFFFF',
              lineHeight: '1.1',
              letterSpacing: '-0.5px',
            }}
          >
            The Edge Most
            <br />
            Investors &amp; Traders
            <br />
            <em style={{ fontStyle: 'italic' }}>NEVER</em> Get Access To...
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-30px' }}
            transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1] }}
            className="text-lg mb-12 leading-relaxed"
            style={{ color: '#9CA3AF', fontFamily: 'DM Sans', maxWidth: '540px' }}
          >
            You're here because Adam personally invited you.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-20px' }}
            transition={{ duration: 1.9, ease: [0.22, 1, 0.36, 1] }}
          >
            <Button
              data-testid="hero-primary-cta-button"
              onClick={() => navigate('/webinar')}
              className="h-16 px-12 text-base inline-flex items-center gap-3 font-bold tracking-wide"
              style={{
                background: 'linear-gradient(135deg, #2563EB 0%, #1E40AF 60%, #1e3a8a 100%)',
                color: '#FFFFFF',
                fontFamily: 'DM Sans',
                fontWeight: 700,
                letterSpacing: '0.5px',
                border: 'none',
                boxShadow: '0 8px 32px rgba(30, 64, 175, 0.45)',
                transition: 'box-shadow 0.18s ease, transform 0.1s ease',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(30, 64, 175, 0.65)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(30, 64, 175, 0.45)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              ACCESS PRIVATE WEBINAR
              <ArrowRight size={16} />
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
